<template>
    <!-- 意向   弹屏 -->
    <a-modal
      v-model="isIntention"
      destroyOnClose
      :footer="null"
      :maskClosable="false"
      :closable="false"
      :width="700"
      centered
    >
      <div class="content-look">
        <div class="title titleIntention">
          <a-icon @click="closeIntentionFn" style="font-size: 16px; cursor: pointer" type="close" />
          <span>点亮意向标识</span>
          <span style="font-size: 16px; color: var(--ThemeColor); cursor: pointer" @click="IntentionOK">确认</span>
        </div>

        <div class="chooseBtn" @click="isLookList = true" style="cursor: pointer">
          <a-icon style="font-size: 18px; margin-right: 10px" type="plus-circle" />
          <span>选择意向房源</span>
        </div>

        <div :class="{ houseListBox: isScroll }" v-if="houseInfoList">
          <div v-for="(v, i) in houseInfoList" :key="v.id">
            <a-row class="house">
              <a-col :span="6">
                <img
                  width="150"
                  height="100"
                  v-if="v.houseInfoImgVo && v.houseInfoImgVo.interiorList"
                  :src="v.houseInfoImgVo.interiorList[0].url"
                  alt=""
                />
                <img width="150" height="100" v-else src="@/assets/images/nodataImg.svg" alt="" />
              </a-col>
              <a-col :span="17" style="padding-left: 10px">
                <h4 style="font-weight: 700; font-size: 16px">{{ v.shopName }}</h4>
                <div>
                  <span style="margin-right: 15px; color: #000">{{ v.businessDistrictName }} </span>
                  <span style="margin-right: 15px; color: #000">{{ v.streetName }} </span>
                  <span style="margin-right: 15px; color: #000">{{ v.grossFloorArea }} m²</span>
                  <span style="margin-right: 15px; color: #000">{{ v.houseFloor }} 1/{{ v.floorTotal }} 层</span>
                  <span style="color: #ff7202; font-weight: 700">{{ v.rentFeeCentiare }} 万/月</span>
                </div>
                <span style="color: #000">编号 {{ v.houseCode }}</span>
              </a-col>
              <a-col :span="1">
                <a-icon style="color: #ff7202; line-height: 100px" type="minus-circle" @click="delItem(i)" />
              </a-col>
            </a-row>
          </div>
        </div>

        <!-- 房源列表弹窗组件 -->
        <template v-if="type === 'tenants'">
          <look-list :isLookList="isLookList" @closeModal="isLookList = $event" @dataList="getListData"></look-list>
        </template>
        <template v-else>
          <sell-look-list
            :isLookList="isLookList"
            @closeModal="isLookList = $event"
            @dataList="getListData"
          ></sell-look-list>
        </template>
      </div>
    </a-modal>
</template>

<script>
import touristApi from '@/api/system/tourist/tourist.js'
import sell_touristApi from '@/api/system/tourist/sell_tourist.js'

import LookList from '@/components/modal/LookList.vue'
import sellLookList from '@/components/modal/sellLookList.vue'

export default {
    components:{
        LookList,
        sellLookList
    },
    props:{
        userId:{
            type:[Number,String],
            default:''
        },
        houseInfoList:{
            type:Array,
            default:()=>[]
        },
        identityStrData:{
            type:Object,
            default:()=>({})
        },
        type:{
          type:String,
          default:''
        }
    },
    watch:{
        houseInfoList: {
            handler(val){
                if (this.houseInfoList && this.houseInfoList.length > 3) {
                this.isScroll = true
                } else {
                this.isScroll = false
                }
            },
            deep:true,
            immediate:true
        },
        identityStrData:{
            handler(){},
            deep:true,
            immediate:true
        }
    },
    data(){
        return {
            isIntention:false,
            isLookList: false,
            isScroll: false, // 带看弹窗是否滚动

        }
    },
    methods:{
        open(){
            this.isIntention = true
        },
        // 关闭意向弹窗
        closeIntentionFn () {
            // this.houseInfoList = []
            this.identityStrData.houseId = []
            
            this.isIntention = false
            this.$emit('resetFile')
        },
        // 意向提交
        IntentionOK () {
            const ids = this.houseInfoList.map((v) => {
                return v.id
            })
            this.identityStrDataFn(ids)
        },
        // 点亮意向-发请求
        identityStrDataFn (ids) {
            this.identityStrData.id = this.$route.query.id
            this.identityStrData.houseId = ids
            this.identityStrData.identityStr = 'Y'
            let port = this.type === 'sale' ?sell_touristApi :touristApi
            port.identityWill({ ...this.identityStrData }).then((res) => {
                if (res.code === 200) {
                    this.$message.success('点亮意向成功')
                    // this.getUserInfo()
                    // this.getRecordList()
                    this.closeIntentionFn()
                    this.$emit('onSuccess')

                }
            })
        },
        // 删除小项
        delItem(item){
            this.$emit('delItem',item)
        },
        getListData(data){
            this.$emit('getListData',data)
        },
    }
}
</script>

<style lang="less" scoped>
//带看
.content-look {
  .title {
    height: 20px;
    line-height: 20px;
    color: #000;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
  }
  .titleIntention {
    min-height: 100px;
  }
//   .textarea {
//     margin-top: 20px;
//     width: 100%;
//     height: 160px;
//     outline: none;
//     border-radius: 10px;
//     border-color: #f1f2f3;
//     padding: 10px;
//     margin-bottom: 20px;
//     resize: none;
//     overflow: hidden;
//   }
  .chooseBtn {
    display: flex;
    align-items: center;
    color: #33c171;
  }

  .houseListBox {
    height: 400px;
    overflow-y: scroll;
  }
  .house {
    margin-top: 10px;
    padding: 10px 14px;
    width: 100%;
    height: 120px;
    background-color: #f9f7fb;
    border-radius: 10px;
    .img {
      width: 100%;
      height: 100px;
      border-radius: 8px;
      background-color: blue;
    }
  }
}
</style>